import React, { useState } from "react";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import {
  Box,
  Typography,
  Tabs,
  Tab,
  TextField,
  Button,
  Grid,
  Card,
  CardContent,
  Select,
  MenuItem,
  InputLabel,
  FormControl,
  Checkbox,
  ListItemText,
  Divider,
  Paper,
  CircularProgress,
} from "@mui/material";
import {
  CalendarToday,
  UploadFile,
  Save,
  Schedule,
  CheckCircle,
  Pending,
  Create,
  Event,
  Approval,
} from "@mui/icons-material";
import { DateTimePicker } from "@mui/x-date-pickers/DateTimePicker";

const platforms = ["Facebook", "Instagram", "Twitter/X", "LinkedIn"];

const ContentScheduler = () => {
  const [activeTab, setActiveTab] = useState(0);
  const [selectedPlatforms, setSelectedPlatforms] = useState([]);
  const [postContent, setPostContent] = useState("");
  const [media, setMedia] = useState(null);
  const [uploading, setUploading] = useState(false);
  const [scheduledPosts, setScheduledPosts] = useState([]);
  const [approvalPosts, setApprovalPosts] = useState([
    { id: 1, title: "Post 1", status: "Pending", platform: "Instagram" },
    { id: 2, title: "Post 2", status: "Approved", platform: "Facebook" },
    { id: 3, title: "Post 3", status: "Changes Requested", platform: "Twitter/X" },
  ]);
  const [accessTokenLinkedIn, setAccessTokenLinkedIn] = useState(null);

  const clientId = "86pw8bvr4jcugz"; // LinkedIn Client ID
  const clientSecret = "WPL_AP1.dgfBhHsSPfV3Tkdo.rEHyTA=="; // LinkedIn Client Secret
  const redirectUri = "http://localhost:5013/auth/linkedin/callback"; // Redirect URI

  const handleTabChange = (event, newValue) => {
    setActiveTab(newValue);
  };

  const handlePlatformChange = (event) => {
    setSelectedPlatforms(event.target.value);
  };

  const handleMediaUpload = (event) => {
    setUploading(true);
    setTimeout(() => {
      setMedia(event.target.files[0]);
      setUploading(false);
    }, 2000); // Simulate upload delay
  };

  const handleSaveDraft = () => {
    alert("Draft saved successfully!");
  };

  const handleSchedulePost = (post) => {
    setScheduledPosts([...scheduledPosts, post]);
    alert("Post scheduled successfully!");
  };

  const handlePublish = () => {
    alert("Post published successfully!");
  };

  // Authenticate with LinkedIn
  const handleLinkedInAuth = () => {
    const linkedInAuthUrl = `https://www.linkedin.com/oauth/v2/authorization?response_type=code&client_id=${clientId}&redirect_uri=${redirectUri}&scope=w_member_social`;
    window.location.href = linkedInAuthUrl;
  };

  // Exchange Authorization Code for LinkedIn Access Token
  const getAccessTokenLinkedIn = async (authorizationCode) => {
    try {
      const response = await fetch("https://www.linkedin.com/oauth/v2/accessToken", {
        method: "POST",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
        body: new URLSearchParams({
          grant_type: "authorization_code",
          code: authorizationCode,
          redirect_uri: redirectUri,
          client_id: clientId,
          client_secret: clientSecret,
        }),
      });

      const data = await response.json();
      setAccessTokenLinkedIn(data.access_token);
      console.log("LinkedIn Access Token:", data.access_token);
    } catch (error) {
      console.error("Error fetching LinkedIn access token:", error);
    }
  };

  // Publish Post to LinkedIn
  const publishToLinkedIn = async () => {
    if (!accessTokenLinkedIn) {
      alert("Please authenticate with LinkedIn first.");
      return;
    }

    try {
      const response = await fetch("https://api.linkedin.com/v2/ugcPosts", {
        method: "POST",
        headers: {
          "Authorization": `Bearer ${accessTokenLinkedIn}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          author: "urn:li:person:YOUR_PERSON_ID", // Replace with your LinkedIn Person ID
          lifecycleState: "PUBLISHED",
          specificContent: {
            "com.linkedin.ugc.ShareContent": {
              shareCommentary: {
                text: postContent,
              },
              shareMediaCategory: "NONE",
            },
          },
          visibility: {
            "com.linkedin.ugc.MemberNetworkVisibility": "PUBLIC",
          },
        }),
      });

      const result = await response.json();
      if (result.id) {
        console.log("Post published to LinkedIn successfully!");
      } else {
        console.error("Error publishing to LinkedIn:", result);
      }
    } catch (error) {
      console.error("Error:", error);
    }
  };

  // Publish Post to Facebook
  const publishToFacebook = async () => {
    const pageAccessToken = "EAAJGp57cEXwBO1iF9jcceZBzQVaG7NjFRuxCkF2X82TwV7mL7AEaL0nr9YOOQNHmZA1FAFdxZCauNuuxnFGdj6B9EzWlCnaFekhvSJi4RjCjL0uaw60KeiWUyyqdq3MP9ZAUFNjZCdhdFv942ndqfKZCKBZBGF2kFHHVFrn6pEUf7pWNjAht0MZCzKjJhWYsIf2AZCKP2ZBsEZByZBZBIPmDWC8zDYVjoHOl2gAuINJNWi6eKJlVEMjVwJ4Ia0ZB22ESSZAMAZDZD"; // Replace with your Facebook Page Access Token
    const pageId = "9701600116588283"; // Replace with your Facebook Page ID
//    https://graph.facebook.com/v12.0/me/accounts?access_token=EAAJGp57cEXwBO1iF9jcceZBzQVaG7NjFRuxCkF2X82TwV7mL7AEaL0nr9YOOQNHmZA1FAFdxZCauNuuxnFGdj6B9EzWlCnaFekhvSJi4RjCjL0uaw60KeiWUyyqdq3MP9ZAUFNjZCdhdFv942ndqfKZCKBZBGF2kFHHVFrn6pEUf7pWNjAht0MZCzKjJhWYsIf2AZCKP2ZBsEZByZBZBIPmDWC8zDYVjoHOl2gAuINJNWi6eKJlVEMjVwJ4Ia0ZB22ESSZAMAZDZD
    try {
      const response = await fetch(`https://graph.facebook.com/${pageId}/feed`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          message: postContent, // The content of the post
          access_token: pageAccessToken,
        }),
      });

      const result = await response.json();
      if (result.id) {
        alert("Post published to Facebook successfully!");
        console.log("Facebook Post ID:", result.id);
      } else {
        console.error("Error publishing to Facebook:", result);
        alert("Failed to publish to Facebook. Check the console for details.");
      }
    } catch (error) {
      console.error("Error:", error);
      alert("An error occurred while publishing to Facebook. Check the console for details.");
    }
  };

  // Publish Post to Twitter
  const publishToTwitter = async () => {
    const bearerToken = "YOUR_TWITTER_BEARER_TOKEN"; // Replace with your Twitter Bearer Token

    try {
      const response = await fetch("https://api.twitter.com/1.1/statuses/update.json", {
        method: "POST",
        headers: {
          "Authorization": `Bearer ${bearerToken}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          status: postContent,
        }),
      });

      const result = await response.json();
      if (result.id_str) {
        console.log("Post published to Twitter successfully!");
      } else {
        console.error("Error publishing to Twitter:", result);
      }
    } catch (error) {
      console.error("Error:", error);
    }
  };

  // Publish Post to Instagram
  const publishToInstagram = async () => {
    const accessToken = "YOUR_INSTAGRAM_ACCESS_TOKEN"; // Replace with your Instagram Access Token
    const instagramAccountId = "YOUR_INSTAGRAM_ACCOUNT_ID"; // Replace with your Instagram Account ID

    try {
      // Step 1: Upload media
      const mediaResponse = await fetch(
        `https://graph.facebook.com/v12.0/${instagramAccountId}/media`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            image_url: "YOUR_IMAGE_URL", // Replace with the URL of the image
            caption: postContent,
            access_token: accessToken,
          }),
        }
      );

      const mediaResult = await mediaResponse.json();
      if (mediaResult.id) {
        // Step 2: Publish media
        const publishResponse = await fetch(
          `https://graph.facebook.com/v12.0/${instagramAccountId}/media_publish`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({
              creation_id: mediaResult.id,
              access_token: accessToken,
            }),
          }
        );

        const publishResult = await publishResponse.json();
        if (publishResult.id) {
          console.log("Post published to Instagram successfully!");
        } else {
          console.error("Error publishing to Instagram:", publishResult);
        }
      } else {
        console.error("Error uploading media to Instagram:", mediaResult);
      }
    } catch (error) {
      console.error("Error:", error);
    }
  };

  // Publish Post to All Platforms
  const publishToAllPlatforms = async () => {
    if (!postContent) {
      alert("Please enter post content before publishing.");
      return;
    }

    console.log("Publishing to selected platforms...");

    // Check if LinkedIn is selected
    if (selectedPlatforms.includes("LinkedIn")) {
      if (!accessTokenLinkedIn) {
        alert("Please authenticate with LinkedIn first.");
        return;
      }
      await publishToLinkedIn();
    }

    // Check if Facebook is selected
    if (selectedPlatforms.includes("Facebook")) {
      await publishToFacebook();
    }

    // Check if Twitter is selected
    if (selectedPlatforms.includes("Twitter/X")) {
      await publishToTwitter();
    }

    // Check if Instagram is selected
    if (selectedPlatforms.includes("Instagram")) {
      await publishToInstagram();
    }

    alert("Post published to all selected platforms successfully!");
  };

  return (
    <LocalizationProvider dateAdapter={AdapterDateFns}>
      <Box sx={{ padding: 4, backgroundColor: "#f9f9f9", minHeight: "100vh" }}>
        <Typography variant="h4" gutterBottom align="center" sx={{ fontWeight: "bold" }}>
          Content Scheduler
        </Typography>
        <Tabs
          value={activeTab}
          onChange={handleTabChange}
          centered
          sx={{
            "& .MuiTab-root": { fontWeight: "bold", textTransform: "none" },
            "& .Mui-selected": { color: "#1976d2" },
          }}
        >
          <Tab icon={<Create />} label="Create New Post" />
          <Tab icon={<Event />} label="Schedule Calendar" />
          <Tab icon={<Approval />} label="Approval Status" />
        </Tabs>

        <Divider sx={{ marginY: 3 }} />

        {activeTab === 0 && (
          <Paper elevation={3} sx={{ padding: 4 }}>
            <Typography variant="h6" gutterBottom>
              Create New Post
            </Typography>
            <FormControl fullWidth sx={{ marginBottom: 2 }}>
              <InputLabel>Platforms</InputLabel>
              <Select
                multiple
                value={selectedPlatforms}
                onChange={handlePlatformChange}
                renderValue={(selected) => selected.join(", ")}
              >
                {platforms.map((platform) => (
                  <MenuItem key={platform} value={platform}>
                    <Checkbox checked={selectedPlatforms.indexOf(platform) > -1} />
                    <ListItemText primary={platform} />
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            <TextField
              label="Post Content"
              multiline
              rows={4}
              fullWidth
              value={postContent}
              onChange={(e) => setPostContent(e.target.value)}
              sx={{ marginBottom: 2 }}
            />
            <Button
              variant="contained"
              component="label"
              startIcon={<UploadFile />}
              sx={{ marginBottom: 2 }}
            >
              Upload Media
              <input type="file" hidden onChange={handleMediaUpload} />
            </Button>
            {uploading && <CircularProgress size={24} sx={{ marginLeft: 2 }} />}
            {media && <Typography sx={{ marginTop: 1 }}>Uploaded: {media.name}</Typography>}

            {/* Preview Section */}
            {selectedPlatforms.length > 0 && postContent && media && (
              <Box sx={{ marginTop: 4, padding: 2, border: "1px solid #ddd", borderRadius: 2 }}>
                <Typography variant="h6" gutterBottom>
                  Post Preview
                </Typography>
                <Typography variant="body1" gutterBottom>
                  <strong>Platforms:</strong> {selectedPlatforms.join(", ")}
                </Typography>
                <Typography variant="body1" gutterBottom>
                  <strong>Content:</strong> {postContent}
                </Typography>
                <Typography variant="body1" gutterBottom>
                  <strong>Media:</strong> {media.name}
                </Typography>
              </Box>
            )}

            <Box sx={{ marginTop: 2 }}>
              <Button
                variant="outlined"
                startIcon={<Save />}
                onClick={handleSaveDraft}
                sx={{ marginRight: 2 }}
              >
                Save Draft
              </Button>
              <Button
                variant="contained"
                color="primary"
                onClick={() => handlePublish()}
                disabled={!selectedPlatforms.length || !postContent || !media}
              >
                Publish
              </Button>
              <Button
                variant="outlined"
                startIcon={<Save />}
                onClick={handleLinkedInAuth}
                sx={{ marginRight: 2 }}
              >
                Authenticate with LinkedIn
              </Button>
              <Button
                variant="contained"
                color="primary"
                onClick={publishToLinkedIn}
                disabled={!postContent}
              >
                Publish to LinkedIn
              </Button>
              <Button
                variant="contained"
                color="primary"
                onClick={publishToAllPlatforms}
                disabled={!postContent}
              >
                Publish to All Platforms
              </Button>
            </Box>
          </Paper>
        )}

        {activeTab === 1 && (
          <Paper elevation={3} sx={{ padding: 4 }}>
            <Typography variant="h6" gutterBottom>
              Schedule Reels/Stories/Posts
            </Typography>
            <Grid container spacing={2}>
              {scheduledPosts.map((post, index) => (
                <Grid item xs={12} sm={6} md={4} key={index}>
                  <Card
                    sx={{
                      "&:hover": { boxShadow: 6 },
                      transition: "box-shadow 0.3s ease-in-out",
                    }}
                  >
                    <CardContent>
                      <Typography variant="body1">{post.title}</Typography>
                      <Typography variant="body2" color="textSecondary">
                        Scheduled for: {post.dateTime}
                      </Typography>
                    </CardContent>
                  </Card>
                </Grid>
              ))}
            </Grid>
            <Box sx={{ marginTop: 3 }}>
              <DateTimePicker
                label="Pick Date & Time"
                onChange={(date) => console.log(date)}
                renderInput={(props) => <TextField {...props} fullWidth />}
              />
              <Button
                variant="contained"
                color="primary"
                startIcon={<Schedule />}
                sx={{ marginTop: 2 }}
                onClick={() => handleSchedulePost({ title: "New Post", dateTime: "2025-04-20 10:00 AM" })}
              >
                Schedule Post
              </Button>
            </Box>
          </Paper>
        )}

        {activeTab === 2 && (
          <Paper elevation={3} sx={{ padding: 4 }}>
            <Typography variant="h6" gutterBottom>
              Approval Status
            </Typography>
            <Grid container spacing={2}>
              {approvalPosts.map((post) => (
                <Grid item xs={12} sm={6} md={4} key={post.id}>
                  <Card
                    sx={{
                      "&:hover": { boxShadow: 6 },
                      transition: "box-shadow 0.3s ease-in-out",
                    }}
                  >
                    <CardContent>
                      <Typography variant="body1">{post.title}</Typography>
                      <Typography variant="body2" color="textSecondary">
                        Platform: {post.platform}
                      </Typography>
                      <Typography variant="body2" color="textSecondary">
                        Status: {post.status}
                      </Typography>
                      {post.status === "Changes Requested" && (
                        <Button
                          variant="outlined"
                          color="secondary"
                          sx={{ marginTop: 1 }}
                          onClick={() => alert("Resubmitted for review!")}
                        >
                          Resubmit for Review
                        </Button>
                      )}
                    </CardContent>
                  </Card>
                </Grid>
              ))}
            </Grid>
          </Paper>
        )}
      </Box>
    </LocalizationProvider>
  );
};

export default ContentScheduler;